// extracted by mini-css-extract-plugin
export default {"container":"style_container__hWfw-","fullWidth":"style_fullWidth__BXmO1"};